import { Component, Vue } from 'vue-property-decorator';
import chooseClass from '@/views/components/productBlackList/chooseClass';

@Component({})
export default class ProductBlackList extends Vue {
  active = 1;
  chooseClass() {
    chooseClass.open().then(() => {
      console.log('ProductBlackList');
    });
  }

  orderConfirm() {
    const urlPrefix = 'alipays://platformapi/startapp?saId=10000007&qrcode=';
    // window.location.href = "http://baidu.com";
    this.active = 2;
  }

  render(h) {
    return (
      <div class="r-pa-20">
        {/* <div class="font-size-14 line-height-32 hei-16 r-pl-10 bg-yellow-6">
          <span class="redText">*&nbsp;</span>
          列入黑名单的商品，顾客在小程序下单时将提示本商品暂不销售。此配置全局生效，加入店铺商品管理白名单的商品不受此限制！
        </div>
        <div class="r-mt-24">
          <span class="font-bold r-pa-32 font-size-15">商品黑名单分类</span>
          <span class="scopeSpan font-size-15" onClick={this.chooseClass.bind(this)}>
            添加分类
          </span>
        </div> */}
        {this.active === 1 && (
          <div class="hei-150 wid-500 font-center r-mt-100">
            <el-button type="primary" onClick={this.orderConfirm.bind(this)}>
              点击下单
            </el-button>
          </div>
        )}
        {this.active === 2 && (
          <div class="hei-150 wid-500">
            <el-image style="object-fit: contain" src="https://img1.baidu.com/it/u=1891894635,198976415&fm=26&fmt=auto"></el-image>
          </div>
        )}
      </div>
    );
  }
}
